import styled from 'styled-components';
import { setLayoutWidth } from 'styles/sharedStyles';
import { Button } from 'components/core';

export const MessageBarContainer = styled.div`
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.13);
  background: ${({ theme }) => theme.palette.primary};
  color: white;
  cursor: pointer;
`;

export const MessageBar = styled.div`
  ${setLayoutWidth};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  flex-basis: 0;

  margin: 0 auto;
  padding: 10px 0;
  text-align: center;

  font-weight: 600;
`;

export const FlashSaleMessage = styled.div`
  padding: 0px 10px;
  text-align: center;
  font-size: 0.95rem;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`;

export const FlashSaleButtonContainer = styled.div`
  text-align: right;
`;

export const FlashSaleButton = styled(Button)`
  text-transform: uppercase;
`;

export const FreeShippingContainer = styled.div<{ fullWidth?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 5px;

  width: ${({ fullWidth }) => (fullWidth ? '100%' : '20%')};
`;

export const Divider = styled.div`
  width: 1px;
  height: 30px;
  background: white;
`;
